/**
 * Brand-touchpoint #1: animated heartbeat dot — связь с core-продуктом
 * (heartbeat = ритм работы AI-агентов в AgentCEO).
 * Уважает prefers-reduced-motion.
 */
export function HeartbeatPulse({ className = '' }: { className?: string }) {
  return (
    <span
      className={`relative inline-flex h-2.5 w-2.5 ${className}`}
      aria-hidden
    >
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-action-primary-bg opacity-60 motion-reduce:animate-none" />
      <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-action-primary-bg" />
    </span>
  );
}
